import { Role } from '../models/role'
import VueRouter, { RouteConfig } from 'vue-router'

import {
  listRoute as judgeListRoute,
  editRoute as judgeEditRoute,
  detailsRoute as judgeDetailsRoute,
  scoreRoute as judgeScoreRoute,
  statsRoute as judgeStatsRoute,
  navigateToCompetitionRegionJudgeList,
  navigateToCompetitionRegionJudgeEdit,
  navigateToCompetitionRegionJudgeScore,
  navigateToCompetitionRegionJudgeStats,
  navigateToCompetitionRegionJudgeDetails,
} from './RCompetitionRegionJudge'

const LayoutEmpty = () => import('../views/LayoutEmpty.vue')

const List = () => import('../views/CompetitionRegionListOrganization.vue')
const Details = () => import('../views/CompetitionRegionDetailsOrganization.vue')
const DetailsInfo = () => import('../views/CompetitionRegionDetailsOrganizationInfo.vue')
const DetailsStats = () => import('../views/CompetitionRegionDetailsOrganizationStats.vue')
const DetailsGroup = () => import('../views/CompetitionRegionDetailsOrganizationGroup.vue')
const DetailsVideosInfo = () => import('../views/CompetitionRegionDetailsOrganizationVideos.vue')
const DetailsParticipant = () => import('../views/CompetitionRegionDetailsOrganizationParticipant.vue')

const Stats = () => import('../views/CompetitionRegionStatsOrganization.vue')
const StatsParticipant = () => import('../views/CompetitionRegionStatsOrganizationParticipant.vue')

const DrillDetailsInfo = () => import('../views/CompetitionRegionDrillDetailsInfo.vue')

export const drillDetailsInfoRoute: RouteConfig = {
  path: 'drill-info',
  name: 'competition_region_drill_details_info',
  component: DrillDetailsInfo,
  props: (route) => ({
    data: JSON.parse(route.query.data as string),
  }),
  meta: {
    title: '区域云比赛',
  },
}

export const listRoute: RouteConfig = {
  path: 'list',
  name: 'competition_region_organization_list',
  component: List,
  meta: {
    title: '区域云比赛',
    showMenu: true,
    roles: [Role.Organization],
  },
}

export const detailsInfoRoute: RouteConfig = {
  path: 'info',
  name: 'competition_region_organization_details_info',
  component: DetailsInfo,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '区域云比赛',
  },
}

export const detailsStatsRoute: RouteConfig = {
  path: 'stats',
  name: 'competition_region_organization_details_stats',
  component: DetailsStats,
  props: (route) => ({
    ...route.query,
    ...route.params,
    region: route.query.region && JSON.parse(route.query.region as string),
  }),
  meta: {
    title: '区域云比赛',
  },
}

export const detailsGroupRoute: RouteConfig = {
  path: 'group',
  name: 'competition_region_organization_details_group',
  component: DetailsGroup,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '区域云比赛',
  },
}

export const detailsParticipantRoute: RouteConfig = {
  path: 'participant',
  name: 'competition_region_organization_details_participant',
  component: DetailsParticipant,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '区域云比赛',
  },
}
export const detailsVideosInfoRoute: RouteConfig = {
  path: 'videos',
  name: 'competition_region_organization_details_video',
  component: DetailsVideosInfo,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '区域云比赛',
  },
}

export const detailsRoute: RouteConfig = {
  path: 'details',
  name: 'competition_region_organization_details',
  redirect: detailsInfoRoute,
  component: Details,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '区域云比赛',
  },
  children: [detailsInfoRoute, detailsStatsRoute, detailsGroupRoute, detailsParticipantRoute, drillDetailsInfoRoute],
}

export const statsRoute: RouteConfig = {
  path: 'stats',
  name: 'competition_region_organization_stats',
  component: Stats,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '区域云比赛',
  },
}

export const statsParticipantRoute: RouteConfig = {
  path: 'stats-participant',
  name: 'competition_region_organization_stats_participant',
  component: StatsParticipant,
  props: (route) => ({ ...route.query, ...route.params, participantId: Number(route.query.participantId!) }),
  meta: {
    title: '区域云比赛',
  },
}

export default [
  {
    path: '/organization/competition-region',
    name: 'competition_region_organization',
    component: LayoutEmpty,
    meta: {
      roles: [Role.Organization],
    },
    redirect: listRoute,
    children: [
      listRoute,
      detailsRoute,
      statsRoute,
      statsParticipantRoute,
      detailsVideosInfoRoute,
      judgeListRoute,
      judgeEditRoute,
      judgeDetailsRoute,
      judgeScoreRoute,
      judgeStatsRoute,
    ],
  },
]

export function navigateToCompetitionRegionStatsOrganization(
  router: VueRouter,
  id: string,
  name: string,
  group_code: string
) {
  router.push({ path: `../${statsRoute.path}`, query: { id, name, group_code } })
}

export function navigateToCompetitionRegionDetailsOrganization(rotuer: VueRouter, id: string, name: string) {
  rotuer.push({ name: detailsInfoRoute.name, query: { id, name } })
}

export { judgeScoreRoute, judgeStatsRoute, judgeListRoute, judgeEditRoute, judgeDetailsRoute }

export {
  navigateToCompetitionRegionJudgeList,
  navigateToCompetitionRegionJudgeEdit,
  navigateToCompetitionRegionJudgeScore,
  navigateToCompetitionRegionJudgeStats,
  navigateToCompetitionRegionJudgeDetails,
}
